export const urlRegex = /^(https?:\/\/)(([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,63})(:[0-9]{1,5})?(\/.*)?$/i
export const domainRegex = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/
export const dateRegex = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/
export const idRegex  = /^[0-9a-zA-Z][0-9a-zA-Z-_]+$/
